import { ApolloLink, FetchResult, NextLink, Operation } from '@apollo/client/core'

const isDevelopment = process.env.VITE_PRODUCTION === 'stag'

const loggerLink = new ApolloLink((operation: Operation, forward: NextLink) => {
  if (!isDevelopment) {
    return forward(operation)
  }

  const startTime = new Date().getTime()

  return forward(operation).map((result: FetchResult) => {
    const operationType =
      operation.query.definitions[0].kind === 'OperationDefinition'
        ? operation.query.definitions[0].operation
        : 'unknown'

    const elapsed = new Date().getTime() - startTime

    const group = [
      `%c${operationType.toUpperCase()} %c${operation.operationName} %c(${elapsed} ms)`,
      'color: #3498db; font-weight: bold;',
      'color: #2ecc71; font-weight: bold;',
      'color: #e74c3c; font-weight: bold;'
    ]

    console.groupCollapsed(...group)
    console.log('%c🟢 INIT', 'color: #27ae60; font-weight: bold;', {
      variables: operation.variables,
      query: operation.query.loc?.source.body,
      operationName: operation.operationName
    })
    console.log('%c🔵 RESULT', 'color: #2980b9; font-weight: bold;', result)
    console.groupEnd()

    return result
  })
})

export default loggerLink
